import axios from "axios";
import { getApiBaseUrl } from "../../../config";

const apiPrefix = getApiBaseUrl("auth");

export const getCities = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/search-city`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const saveClientData = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/create-client`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getClientData = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/client-list`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const checkNameAvailability = async (token, formData) => {
  return await axios.post(
    `${apiPrefix}/api/v1/check-name-availability`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const searchClient = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/search-client`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getClientDetails = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/client-info`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCategoriesByClient = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/client-categories-list`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const getClientSpecificCategory = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/client-dashboard-info`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const deleteCustomRecruit = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/delete-custom-recruit`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
